import BaseService from "@/services/BaseService";

class CidadeService extends BaseService {
  constructor() {
    super("/v1/cidades");
  }
}

export default new CidadeService();
